var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_c('coozzy-page-title',{attrs:{"title":_vm.$t('message.userRequests.title'),"count":_vm.requestList.length,"count-text":_vm.$t('message.generic.requests')}}),_vm._l((_vm.requestList),function(request){return _c('coozzy-card',{key:request.id},[_c('application-form-object-view',{attrs:{"request-id":request.id}})],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }